import template from './modalDelegationManager.html';
import controller from './modalDelegationManager.controller';
import './modalDelegationManager.scss';

let modalDelegationManagerComponent = {
  restrict: 'E',
  bindings: {
    isMobileApp: '<',
    state: '<',
    delegation: '<',
    message: '<',
    customTitle: '<',
    moduleId: '<',
    modalClose: '&',
    editDelegationRequest: '&',
    onSendDelegation: '&',
    employeeRole: '<',
    cancelDelegationRequest: '&',
    setDelegationType: '&',
    employeeId: '<',
  },
  template,
  controller,
};

export default modalDelegationManagerComponent;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalDelegationManager.component.js